// tenant/TenantContext.tsx
import { useAppDispatch } from 'context/AppContext';
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useQueryClient } from 'react-query';

type TenantContextValue = {
  tenantId: string | null;
  setTenantId: (id: string | null) => void;
};

const TenantContext = createContext<TenantContextValue | undefined>(undefined);

export const TenantProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch(); // hvis du har dispatch i AppContext
  const [tenantId, setTenantIdState] = useState<string | null>(() =>
    localStorage.getItem('tenantId')
  );

  const setTenantId = (id: string | null) => {
    setTenantIdState(id);
    if (id) localStorage.setItem('tenantId', id);
    else localStorage.removeItem('tenantId');
  };

  // Når tenant endres -> clear caches + reset state
  useEffect(() => {
    if (!tenantId) return;

    queryClient.clear(); // tømmer react-query cache
    dispatch({ type: 'RESET_TENANT_STATE' }); // lag denne actionen om du ikke har den
  }, [tenantId, queryClient, dispatch]);

  const value = useMemo(() => ({ tenantId, setTenantId }), [tenantId]);

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  );
};

export const useTenant = () => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant må brukes inne i TenantProvider');
  return ctx;
};
